<template>
  <input type="tel"
        v-model="displayValue"
        v-restrict.number
        @blur="setActive(false)"
        @focus="setActive(true)"/>
</template>

<script>
export default {
    name: 'mvtInputInt',
    emits: ['update:modelValue'],
    props: {
        modelValue: {
            required: true
        },
        placeholder: {
            type: String,
            default: ''
        }
    },
    data: function() {
        return {
            actived: false,
            val: this.modelValue || 0
        }
    },
    watch: {
        modelValue() {
            this.val = this.modelValue;
        }
    },
    methods: {
        setActive(actived) {
            this.actived = actived;
            if (this.actived) {
                this.$emit('actived');
            }
        },
    },
    computed: {
        displayValue: {
            get: function() {
               if (this.actived) {
                    return this.val;
                } else if(!(this.val>0) && this.placeholder){
                    return this.placeholder;
                } else {
                    return this.val || this.placeholder;
                }
            },
            set: function(modifiedValue) {
                let newValue = parseFloat(modifiedValue.replace(/[^\d\.]/g, ''))
                if (isNaN(newValue)) {
                    newValue = 0
                }
                this.val = newValue;
                this.$emit('update:modelValue', this.val);
            }
        }
    }
}
</script>
